import React, { useState, useEffect } from 'react';

const UpperMiddleBlock = ({ operationsData }) => {
    console.log("operationsData: ", operationsData);
    const [totalSpent, setTotalSpent] = useState(0);
    const [totalIncome, setTotalIncome] = useState(0);

    useEffect(() => {
        if (operationsData && operationsData.invoices) {
            const now = new Date();
            const currentMonth = now.getMonth();
            const currentYear = now.getFullYear();
            
            let totalIn = 0;
            let totalOut = 0;
            
            operationsData.invoices.forEach(operation => {
                if (operation.date_operation && operation.status) {
                    const operationDate = new Date(operation.date_operation);
                    if (operationDate.getMonth() === currentMonth && operationDate.getFullYear() === currentYear) {
                        if (operation.operation === 'in') {
                            totalIn += operation.paid;
                        } else if (operation.operation === 'out') {
                            totalOut += operation.paid;
                        }
                    }
                }
            });
            
            setTotalIncome(totalIn);
            setTotalSpent(totalOut);
        }
    }, [operationsData]);
    return (
        <div className="my-flows-upper-middle">
        <svg width="106.8" height="108" viewBox="0 0 89 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M45.45 0C54.4779 1.08198e-07 63.274 2.87241 70.5778 8.20555C77.8815 13.5387 83.3178 21.0588 86.1076 29.688C88.8974 38.3172 88.8974 47.6125 86.1076 56.2417C83.3178 64.8709 77.8815 72.391 70.5778 77.7241L45.45 42.9648V0Z" fill="#3745AF"/>
            <path opacity="0.3" d="M42.75 4.07031C36.0036 4.07031 29.353 5.67501 23.3419 8.7532C17.3308 11.8314 12.13 16.2957 8.16452 21.781C4.19909 27.2664 1.58169 33.6171 0.526323 40.314C-0.529045 47.0108 0.00758357 53.8636 2.09233 60.312C4.17709 66.7604 7.75076 72.6215 12.5212 77.4159C17.2916 82.2103 23.1233 85.8019 29.5395 87.8971C35.9557 89.9923 42.7742 90.5317 49.4376 89.471C56.1009 88.4103 62.4199 85.7798 67.8778 81.7944L42.75 47.0351V4.07031Z" fill="#3745AF"/>
        </svg>
        <div className="my-flows-amount">
            <span className="my-flows-amount-spent">{new Intl.NumberFormat('ru-RU').format(totalSpent)} ₽</span>
            <span className="my-flows-amount-total"> / {new Intl.NumberFormat('ru-RU').format(totalIncome)} ₽</span>
        </div>
        <div className="my-flows-amount-period">
            потрачено за {new Date().toLocaleDateString('ru-RU', { month: 'long' })}
        </div>
        </div>
    );
};

export default UpperMiddleBlock;